Date.prototype.toDateInputValue = (function () {
    let local = new Date(this);
    local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
});

export const sexItems = {
    1: 'M',
    2: 'F',
    3: 'MC',
}
export const sexArray = ['N/A', "Mâle", 'Femelle', 'Mâle castré'];

export const eventType = {
    1: 'Déplacement',
    2: 'Marqueur',
    3: 'Pesée',
    5: 'Mise bas',
    6: 'Sortie',
    4: 'Autre',
};

// export const exitType = {
//     1: 'Abattage',
//     2: 'Décès',
//     3: 'Vente'
// };

export const typeArray = ['N/A', 'Déplacement', 'Marqueur', 'Pesée', 'Autre', 'Mise bas', 'Sortie'];
export const exitTypeArray = ['N/A', 'Abattage', 'Décès', 'Vente'];

const today = new Date();
const dateInterval =  {
    today: today.toDateInputValue() + 'T00:00:00+01:00',
    sixMonthAgo: new Date(new Date().setMonth(today.getMonth()-6)).toDateInputValue() + 'T00:00:00+00:00',
    twelveMonthAgo: new Date(new Date().setMonth(today.getMonth()-12)).toDateInputValue() + 'T00:00:00+00:00',
    aLongTimeAgo: new Date(new Date().setMonth(today.getMonth()-360)).toDateInputValue() + 'T00:00:00+00:00',
}
export const birthdayList = {
    [dateInterval.sixMonthAgo + "--" + dateInterval.today]: 'Moins de 6 mois',
    [dateInterval.twelveMonthAgo + "--" + dateInterval.sixMonthAgo]: '6 mois à moins d\'un an',
    [dateInterval.aLongTimeAgo + "--" + dateInterval.twelveMonthAgo]: 'Plus d\'un an'
}
export const weightList = {
    '0--5': 'Moins de 5 kg',
    '5--15': '5 à moins de 15 kg',
    '15--35': '15 à moins de 25kg',
    '35--50': '35 à moins de 50kg',
    '50--999': 'Plus de 50kg',
}

export default sexItems;